import React, { Ref } from 'react';
import Async from 'react-select/async';
import { GroupBase, OptionsOrGroups, Props } from 'react-select';
import { useKitSelectStyles } from './KitSelect';

export interface ExtendedProps extends Props {
  isError?: boolean;
  selectRef?: Ref<Async>;
  loadOptions?: (val: unknown) => Promise<OptionsOrGroups<typeof Option, GroupBase<typeof Option>>>;
}

const KitSelectAsync = React.forwardRef<Async, ExtendedProps>(({ isError, ...otherProps }, ref) => (
  <Async
    styles={useKitSelectStyles(isError)}
    aria-invalid={isError}
    selectRef={ref}
    {...otherProps}
  />
));

export default KitSelectAsync;
